import React, { useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Imgix from 'react-imgix'

// Components
import ImageWrapper from './ImageWrapper'

// Hooks
import useIntersectionObserver from '../../hooks/useIntersectionObserver'

// Utils
import { formatSizes, calculateHeightFromAspectRatio, queryStringAlreadyExists } from './utils'

// Styles
const useStyles = makeStyles((theme) => ({
  full: {
    transition: 'opacity 400ms ease 0ms',
  },
  thumb: {
    opacity: 1,
    transition: 'opacity 0ms ease 400ms',
  },
  invisible: {
    opacity: 0,
  },
}))

const ReactImgix = (props) => {
  const classes = useStyles(props)
  const ref = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  // console.log('👾 ReactImgix', props)
  const {
    alt,
    aspectRatio,
    backgroundColor,
    height,
    imgClassName,
    imgStyle,
    objectFit,
    objectPosition,
    role,
    sizes,
    src,
    styles,
    width,
    wrapperClassName,
    wrapperStyle,
  } = props

  const fileName = src.split('/assets/')[1]

  useIntersectionObserver({
    target: ref,
    onIntersect: ([{ isIntersecting }], observerElement) => {
      if (isIntersecting) {
        setIsVisible(true)
        observerElement.unobserve(ref.current)
      }
    },
  })

  // console.log('👾 ReactImgix', fileName)
  return (
    <ImageWrapper
      alt={alt}
      aspectRatio={aspectRatio}
      backgroundColor={backgroundColor}
      childRef={ref}
      objectFit={objectFit}
      objectPosition={objectPosition}
      height={calculateHeightFromAspectRatio(width, height, aspectRatio)}
      styles={`${styles}`}
      width={width}
      wrapperClassName={`${styles} ${wrapperClassName} imageWrapper`}
      wrapperStyle={wrapperStyle}
    >
      {isVisible && (
        <>
          <img
            className={`${classes.thumb} ${imgClassName} image ${
              isLoaded ? classes.invisible : null
            }`}
            src={`${process.env.GATSBY_IMGIX_SOURCE_DOMAIN}/${fileName}${
              queryStringAlreadyExists ? '&' : '?'
            }w=100&blur=15&q=15&auto=format`}
            alt=""
            style={{ ...imgStyle }}
            width={width}
            height={calculateHeightFromAspectRatio(width, height, aspectRatio)}
          />
          <Imgix
            className={`${classes.full} ${imgClassName}`}
            src={`${process.env.GATSBY_IMGIX_SOURCE_DOMAIN}/${fileName}`}
            sizes={sizes ? formatSizes(sizes) : '100vw'}
            htmlAttributes={{
              draggable: 'false',
              height: calculateHeightFromAspectRatio(width, height, aspectRatio),
              onLoad: () => setIsLoaded(true),
              role,
              style: { opacity: isLoaded ? 1 : 0, ...imgStyle },
              width,
            }}
          />
        </>
      )}
    </ImageWrapper>
  )
}

export default ReactImgix
